import { useState } from "react";
import { PageHero, SHELL, Reveal } from "@/components/bits";
import { FAQS } from "@/lib/data";
import { Plus } from "lucide-react";
import { Link } from "react-router-dom";

export default function Faq() {
    const [open, setOpen] = useState(0);
    return (
        <div data-testid="faq-page">
            <PageHero
                label="FAQ"
                title={"QUESTIONS, ANSWERED\nFACTUALLY."}
                sub="If information is not available yet, the answer is Coming Soon — never invented."
            />
            <section className="py-20 md:py-28">
                <SHELL>
                    <div className="max-w-3xl mx-auto space-y-3" data-testid="faq-list">
                        {FAQS.map((f, i) => {
                            const isOpen = open === i;
                            return (
                                <Reveal key={f.q} delay={Math.min(i * 0.03, 0.2)}>
                                    <div className={`glass-card transition-colors ${isOpen ? "border-vera-gold/40" : "hover:border-white/20"}`} data-testid={`faq-item-${i + 1}`}>
                                        <button
                                            type="button"
                                            onClick={() => setOpen(isOpen ? -1 : i)}
                                            aria-expanded={isOpen}
                                            data-testid={`faq-question-${i + 1}`}
                                            className="w-full flex items-center justify-between gap-6 px-6 md:px-8 py-5 text-left"
                                        >
                                            <span className={`font-bold text-sm sm:text-base ${isOpen ? "text-vera-gold2" : "text-vera-white"}`}>{f.q}</span>
                                            <Plus className={`w-4 h-4 text-vera-mut shrink-0 transition-transform duration-300 ${isOpen ? "rotate-45" : ""}`} aria-hidden="true" />
                                        </button>
                                        {isOpen && (
                                            <div className="px-6 md:px-8 pb-6">
                                                <p className="text-sm text-vera-mut leading-relaxed border-t border-white/10 pt-5">{f.a}</p>
                                            </div>
                                        )}
                                    </div>
                                </Reveal>
                            );
                        })}
                    </div>
                    <Reveal>
                        <p className="text-center text-sm text-vera-mut mt-14">
                            More questions? Read the{" "}
                            <Link to="/docs" data-testid="faq-docs-link" className="text-vera-soft hover:text-white underline underline-offset-4">
                                documentation
                            </Link>{" "}
                            or verify the{" "}
                            <Link to="/proof" data-testid="faq-proof-link" className="text-vera-soft hover:text-white underline underline-offset-4">
                                official sources
                            </Link>
                            .
                        </p>
                    </Reveal>
                </SHELL>
            </section>
        </div>
    );
}
